import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { DeclineInfoDialogComponent } from 'ng2-app/components/decline-info-dialog/decline-info-dialog.component';
import { DeclineInfoActivityDialogTriggerComponent } from 'ng2-app/components/decline-info-dialog/decline-info-activity-dialog-trigger.component';
import { DeclineInfoTooltipComponent } from 'ng2-app/components/decline-info-dialog/decline-info-tooltip.component';

@NgModule({
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIcon,
  ],
  declarations: [
    DeclineInfoDialogComponent,
    DeclineInfoActivityDialogTriggerComponent,
    DeclineInfoTooltipComponent,
  ],
  exports: [
    DeclineInfoDialogComponent,
    DeclineInfoActivityDialogTriggerComponent,
    DeclineInfoTooltipComponent,
  ]
})
export class DeclineInfoDialogModule { }
